import React, { useContext } from "react";
import { Button } from "reactstrap";
import "../../assets/scss/navbar/navbar.scss";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import classNames from "classnames";
import { isMobileOnly } from "react-device-detect";
import SidebarLinksComponent from "../widgets/SidebarLinksComponent";
import { ITenant } from "../../app/models/tenant";
import SidebarLogo from "./SidebarLogo";
import SurveyButton from "../buttons/SidebarSurveyButton";
import RepositoryButton from "../buttons/SidebarRepositoryButton";
import classnames from "classnames";
import SidebarOdgButton from "../buttons/SidebarOdgButton";
import SidebarArchiveButton from "../buttons/SidebarArchiveButton";

interface IParams {
  tenant: ITenant;
  currentUrl?: string;
  goBack: () => void;
}

const Sidebar: React.FC<IParams> = ({ tenant, currentUrl, goBack }) => {
  const rootStore = useContext(RootStoreContext);
  const {isOfflineModeEnabled } =
    rootStore.commonStore;
  const { theme } = rootStore.commonStore;
  const {isMobileMediaQuery} = rootStore.responsiveStore
  if (!isMobileMediaQuery) {
    document.body.classList.add("NavbarShift");
  }
  else{
    document.body.classList.remove("NavbarShift")
  }

  //// COMMENTED FOR FIXED SIDEBAR
  // const handleDrawerClosed = () => {
  //   changeSidebar();
  //   document.body.classList.remove("NavbarShift");
  // };

  return (
    <div>
      {!isMobileMediaQuery ? (
        <nav
          className={classNames(
            "navigation d-table ",
            `${theme?.sidebarColor}`,
            isMobileMediaQuery ? "sidebarMobile fixed-top" : "sidebar"
          )}
        >
          <div
            className={classNames(
              "nav-group",
              `border-${theme?.sidebarBorder}`,
              isMobileMediaQuery ? "sidebarMobile fixed-top" : "sidebar"
            )}
          >
            <div
                className={classNames("mb-2 ", `${theme?.sidebarColor}`)}
                style={{ height: "40px" }}
              >
                {/* <Button
                  onClick={handleDrawerClosed}
                  color="inherit"
                  className={classnames(
                    `text-${theme!.sidebarBurgherButton}`,
                    "text-center burgherButton",
                    `border-bottom-${theme?.sidebarBorder}`
                  )}
                >
                  <i
                    className={classNames("fas fa-bars fa-lg")}
                    // style={{ color: "black" }}
                  ></i>
                </Button> */}
                                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    goBack();
                  }}
                  color="inherit"
                  className={classnames(
                    `${theme!.sidebarBurgherButton}`,
                    "text-center burgherButton",
                    `border-bottom-${theme?.sidebarBorder}`
                  )}
                >
                  <i
                    className={classNames("fa fa-arrow-left fa-lg")}
                    // style={{ color: "black" }}
                  ></i>
                </Button>
              </div>
              <div className="sideScrollbarInvisible" style={{
                maxHeight: "calc(100vh - 40px - 72px - 11px)",
                overflowY: "auto",
              }}>
            <ul style={{height: "100%"}}>
              
              {!isOfflineModeEnabled ?
              <li>
                <SidebarOdgButton tenant={tenant} currentUrl={currentUrl} ></SidebarOdgButton>
              </li>
              :null
              }
              <li className="mb-4">
                <SidebarLinksComponent
                  tenant={tenant}
                  currentUrl={currentUrl}
                />
              </li>
              
              <li>{!isOfflineModeEnabled && <SurveyButton />}</li>
              <li>
                <RepositoryButton tenant={tenant} currentUrl={currentUrl} />
              </li>
              <li>
                <SidebarArchiveButton tenant={tenant} currentUrl={currentUrl} />
              </li>
              
            </ul>
            </div>
            <div className="sidebar-logo-container">
                {/* <div className=" pt-0 pb-0">
                  <Link to={`#`} className=" pb-0">
                    <SidebarGenericButton
                      icon={"fa fa-arrow-left"}
                      label={"Indietro"}
                      isActive={false}
                      onClick={(e) => {
                        e.preventDefault();
                        goBack();
                      }}
                    />
                  </Link>
                </div> */}
                <SidebarLogo tenant={tenant} />
              </div>
          </div>
        </nav>
      ) : null}
    </div>
  );
};

export default observer(Sidebar);
